const pageNames = {
  CHECKOUT: 'Checkout',
  DETAILS: 'About You',
  REVIEW: 'Your order',
  SERVEDUP: 'Sessions Serve',
};

export default pageNames;
